import React, { createRef } from "react";
import { doFetch } from "../../../api/apiFetchHelper";
import { Button } from "@accessdev/arc-ui-react";
import RedeemError from "./RedeemError";
import { DealsContext, REDEMPTION_TYPES } from "@Src/routes/deals/Deals.context";
import { Trans } from "@lingui/react/macro";
import { TranslateAsync } from "@Src/components/Translation";
import { handleInterstitialRedirect } from "@Src/utils/redirectUtility";

class Coupon extends React.Component {
  static contextType = DealsContext;
  constructor(props) {
    super(props);
    this.state = {
      showcoupon: false,
      isLinkRedemption: false,
      redeemData: "",
      link: "",
      promoCode: "",
      display: "",
      redeemError: false,
      isLoading: false,
    };
    this.extLinkRef = createRef();
    this.focusRef = createRef();
  }

  componentDidMount() {
    document.querySelector("body").classList = "coupon-open";
    this.loadRedeem(this.props.redeem_link);
  }

  componentDidUpdate() {
    if (this.extLinkRef.current) {
      this.attachLinkClickEvent();
    }
  }

  componentWillUnmount() {
    document.querySelector("body").classList = "";
  }

  buildInterstitialContent = (url) => {
    const { name, logo_url, image_url } = this.props.store_info;
    const { program_logo, program_color } = this.props.program;

    const programName = this.props.program.name;
    const language = this.props.language;
    const storeData = {
      store_name: name,
      store_logo_url: logo_url || image_url,
      store_url: url,
      program_name: programName,
      program_color: program_color,
      program_logo: program_logo,
      language: language,
    };
    handleInterstitialRedirect(storeData);
  };

  attachLinkClickEvent = () => {
    // If the link is an external link, we need to attach a click event to all
    // the "A" tags to handle the external redirects correctly
    //
    // Deplay the action of attaching the click event to make sure the DOM is ready
    setTimeout(() => {
      const arr = document.querySelectorAll(".redeemLinkInstructions a");
      arr.forEach((el) => {
        el.addEventListener("click", (event) => {
          if (event.isTrusted) {
            event.preventDefault();
            const url = event.target.href;
            this.buildInterstitialContent(url);
          }
        });
      });
    }, 500);
  };

  handleFocusButton = () => {
    if (this.focusRef.current) {
      this.focusRef.current.focus();
    }
  };

  loadRedeem = (url) => {
    let ctx = this.context;
    this.setState({
      redeemError: false,
      isLoading: true,
    });
    ctx.setHasRedeemError(false);
    doFetch(url)
      .then((data) => {
        this.handleFocusButton();
        if (data.message) {
          this.setState({
            message: data.message,
            isLoading: false,
          });
        } else {
          this.setState(
            {
              redeemData: data,
              link: data.details.link,
              promoCode: data.details.promotion_code,
              display: data.details.display,
              isLoading: false,
            },
            () => {
              if (this.props.offer.uses_per_period !== "unlimited") {
                ctx.setRedeemedLimitedOffer(true);
              }
              this.handleLinkRedemptions();
            },
          );
        }
      })
      .catch((err) => {
        this.handleFocusButton();
        console.warn("There was a network error when trying to retrieve the coupon: ", err);
        this.setState({
          redeemError: true,
          isLoading: false,
        });
        ctx.setHasRedeemError(true);
      });
  };

  handleCopy() {
    document.querySelector("#code").select();
    document.execCommand("copy");
  }

  setDisplayHtml = (display) => {
    if (!display) return null;
    return <TranslateAsync text={display} displayHTML={true} />;
  };

  setContentTitle = (couponOnly) => {
    return (
      <h2 className="t-headline-large">
        <Trans>Score!</Trans>
      </h2>
    );
  };

  handleLinkRedemptions = () => {
    const { link, redeemData } = this.state;
    const { redeem_type } = this.props;

    const isUnsupportedIFrame = () => {
      const instructionsAndLink = redeemData.details.display && redeemData.details.link;

      if (redeem_type !== REDEMPTION_TYPES.ONLINE && instructionsAndLink) {
        return true;
      }
      return false;
    };

    if (link) {
      if (redeem_type === REDEMPTION_TYPES.ONLINE || isUnsupportedIFrame()) {
        this.setState({ isLinkRedemption: true });
      }
    }
  };

  renderLinkContent = (linkDisplay) => {
    if (this.state.promoCode) {
      return (
        <>
          {linkDisplay ? (
            linkDisplay
          ) : (
            <p className="opaque t-body-large">
              <Trans>To redeem, copy and enter the promo code at checkout.</Trans>
            </p>
          )}

          <p className="opaque t-headline-small">
            <Trans>Your Custom Code</Trans>
          </p>
          <span className="copy__redeem">
            <input defaultValue={this.state.promoCode} id="code" readOnly={true} tabIndex={-1} />
            <button
              className="copy__redeem--button t-title-med"
              onClick={this.handleCopy.bind(this)}
            >
              <Trans>Copy</Trans>
            </button>
          </span>
          <a
            href={this.state.link}
            onClick={(e) => e.preventDefault()}
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={-1}
          >
            <Button
              className="continue__redeemBtn"
              onClick={() => this.buildInterstitialContent(this.state.link)}
            >
              <Trans>Continue to Site</Trans>
            </Button>
          </a>
        </>
      );
    } else {
      return <p>{linkDisplay}</p>;
    }
  };

  render() {
    const { display, link, isLinkRedemption, isLoading } = this.state;
    let { redeem_type } = this.props;
    let linkDisplay = display;
    const isInstoreCoupon =
      (redeem_type === REDEMPTION_TYPES.SHOW || redeem_type === REDEMPTION_TYPES.PRINT) &&
      !isLinkRedemption;

    if (isLinkRedemption) {
      redeem_type = "link";
      linkDisplay = (
        <span ref={this.extLinkRef} className="redeemLinkInstructions t-body-large">
          {this.setDisplayHtml(display)}
        </span>
      );
    }

    return (
      <div className={`coupon__content ${redeem_type}`}>
        <div ref={this.focusRef} className="coupon__focus-target" tabIndex={-1} />
        {isInstoreCoupon && link && (
          <div id="coupon_iframe" className="coupon-iframe">
            <iframe title="coupon" src={link} scrolling="no" />
          </div>
        )}

        {isLinkRedemption && (
          <div className="coupon__redeem-content">
            {this.setContentTitle()}
            {this.renderLinkContent(linkDisplay)}
          </div>
        )}

        {display !== "" && redeem_type === REDEMPTION_TYPES.CALL && (
          <div className="coupon__redeem-content">
            {this.setContentTitle()}
            <p>{this.setDisplayHtml(display)}</p>
          </div>
        )}

        {this.state.message && (
          <div className="coupon__redeem-content-bg">{this.state.message}</div>
        )}

        {this.state.redeemError && (
          <RedeemError
            btnText="Try Again"
            btnCallback={(event) => this.loadRedeem(this.props.redeem_link)}
          />
        )}

        {isLoading && (
          <p className="coupon__loading">
            <Trans>Loading..</Trans>
          </p>
        )}
      </div>
    );
  }
}

export default Coupon;
